const VI_NUMBER = new Intl.NumberFormat("vi-VN");

/** Chiều cao thanh đầu khối (Loại phiếu / Bên xuất), gồm viền dưới: hai cột dùng chung để thẳng hàng */
export const TOP_BAR_HEIGHT = 60;
/** Chiều cao hàng tiêu đề lưới serial (AG Grid tự cộng thêm 1px viền dưới) */
export const TABLE_HEAD_HEIGHT = 36;

/** Định dạng số kiểu Việt Nam (20.990.000), dùng chung cho mọi bảng trên trang */
export const formatNumberVi = (value: number | null | undefined) =>
  value == null || Number.isNaN(Number(value)) ? "" : VI_NUMBER.format(Number(value));
